import { useStore } from 'effector-react';
import { useEffect, useState } from 'react';
import Alert, { AlertSeverity } from 'components/Alert';
import NoContent from 'components/NoContent';
import Preloader from 'components/Preloader';
import GridBody from 'components/table/GridBody';
import GridCell from 'components/table/GridCell';
import GridHead from 'components/table/GridHead';
import GridRow from 'components/table/GridRow';
import GridTable from 'components/table/GridTable';
import { getGatewaysFx } from 'models/gateways/effects';
import { gatewaysList } from 'models/gateways/store';
import { NeedHelpBlock } from 'views/common/NeedHelpBlock';
import { ReleaseUpdateAlert } from 'views/common/ReleaseUpdateAlert';
import { SensorsWrapper } from '..';
import GatewayItem from './GatewayItem';
import styles from './index.module.css';
import NoGatewayBlock from './NoGatewayBlock';

function SensorsDIM() {
	const gateways = useStore(gatewaysList).filter((gateway) => !gateway.is_deleted);
	const [isLoading, setLoading] = useState(false);
	const isContent = gateways.length !== 0;

	useEffect(() => {
		setLoading(true);
		getGatewaysFx().then(() => {
			setLoading(false);
		});
	}, []); // Fetch gateways from server, once.

	return (
		<SensorsWrapper>
			<Alert
				severity={AlertSeverity.info}
				header="Statuses updated every minute. Reload the page to see status changes."
				className={styles.alert}
				dataTest="sensor-status-info"
			/>

			<ReleaseUpdateAlert type="dim" />

			<GridTable dataTest="gateways-table" className={styles.table}>
				<GridHead>
					<GridRow head className={styles.rowContainer}>
						<GridCell head>Name</GridCell>
						<GridCell head>Region</GridCell>

						<GridCell className={styles.tokenCell} head>
							Token
						</GridCell>
					</GridRow>
				</GridHead>

				<GridBody>
					<Preloader isLoading={isLoading}>
						{isContent ? (
							gateways.map((gateway) => <GatewayItem gateway={gateway} key={gateway.id} />)
						) : (
							<NoContent type="gateway" className={styles.rowContainer} />
						)}
					</Preloader>
				</GridBody>
			</GridTable>

			{!isContent && !isLoading && <NoGatewayBlock />}

			{isContent && <NeedHelpBlock />}
		</SensorsWrapper>
	);
}

export { SensorsDIM };
